// Add a URL mapping system based on redirects in vercel.json
const urlRedirectMap = {
  // Map from old blog URLs to new page URLs
  '/blogs/stories/1-for-the-wild/our-sustainable-sourcing-standards': '/pages/our-sustainable-sourcing-standards',
  // Add more mappings as needed
};

/**
 * Maps a potentially old URL to its new destination based on redirects
 * @param {string} url - The original URL to check
 * @returns {string} - The mapped URL or the original if no mapping exists
 */
export const mapRedirectedUrl = (url) => {
  return urlRedirectMap[url] || url;
};

/**
 * Generates the correct URL for an article or page from search results
 * @param {Object} item - The search result item
 * @param {(string|Object)} item.handle - The handle of the item, can be either a string or an object with a 'current' property
 * @param {Object} [item.fields] - Optional fields containing typename and blog information
 * @param {string} [item._type] - The type of the item if not in fields
 * @param {Object} [item.blog] - Blog information if not in fields
 * @returns {string} - The correct URL for the item, with appropriate prefix based on type (/pages/ for pages, /blogs/ for blog posts)
 */
export const getSearchResultUrl = (item) => {
  const handle = typeof item.handle === 'object' ? (item.handle?.current ?? undefined) : item.handle;
  const itemType = item.fields?.__typename ?? item._type;
  const blog = item.fields?.blog ?? item.blog;

  let url = `/${handle}`;

  // Generate the URL based on content type
  if (itemType === 'page' || itemType === 'infoPage') {
    url = `/pages/${handle}`;
  } else if (blog) {
    const blogType = blog.blogType;
    const blogHandle = typeof blog.handle === 'object' ? (blog.handle?.current ?? undefined) : blog.handle;
    url = `/blogs/${blogType}/${blogHandle}/${handle}`;
  }

  return mapRedirectedUrl(url);
};

// Export any existing functions from this file
export * from './urlUtils';